import classNames from 'classnames';

import styles from './toggle.module.scss';

interface Props {
    value: boolean;
    onToggle: (value: boolean) => void;
    disabled?: boolean;
}

const Toggle = ({ value, disabled, onToggle }: Props) => {
    const toggle = () => {
        if (disabled) return;
        onToggle(!value);
    };

    return (
        <div
            className={classNames({
                [styles.container]: true,
                [styles.active]: value,
                [styles.disabled]: disabled,
            })}
            onClick={toggle}
        >
            <div
                className={classNames({
                    [styles.circle]: true,
                    [styles.disabled]: disabled,
                })}
            />
        </div>
    );
};

export default Toggle;
